import { useEffect, useMemo } from 'react';
import { useLiveResultsContext } from './features/results/context/LiveResultsContext';
import { normalizeGroupValue, serializeGroupValue } from './features/results/utils/group';

const useStageResults = (
  eventId,
  selectedCompetitionID,
  selectedStageID,
  selectedClassificationID,
  selectedGroupID
) => {
  const {
    getResultsForSelection,
    loading: connectionLoading,
    error,
    dataVersion,
    requestStageResults,
  } = useLiveResultsContext();

  const groupKey = useMemo(
    () => serializeGroupValue(normalizeGroupValue(selectedGroupID)),
    [selectedGroupID]
  );

  const eventKey = useMemo(() => String(eventId ?? ''), [eventId]);

  const selectionResults = useMemo(
    () =>
      getResultsForSelection(
        selectedCompetitionID,
        selectedStageID,
        selectedClassificationID,
        groupKey
      ),
    // dataVersion/eventKey celowo w deps: wyniki muszą się przeliczyć po każdej
    // delcie WS, nawet gdyby tożsamość getResultsForSelection się nie zmieniła.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      getResultsForSelection,
      selectedCompetitionID,
      selectedClassificationID,
      selectedStageID,
      groupKey,
      dataVersion,
      eventKey,
    ]
  );

  useEffect(() => {
    if (!selectedStageID) {
      return;
    }

    requestStageResults(selectedStageID);
  }, [requestStageResults, selectedStageID]);

  return {
    stageResults: selectionResults.stageResults || [],
    afterStageResults: selectionResults.afterStageResults || [],
    loading: connectionLoading || !selectionResults.isLoaded,
    error,
  };
};

export default useStageResults;
